import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-black bg-white p-5 w-full min-h-[160px]" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "font-semibold text-5xl flex flex-col mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col w-full",
  "aria-label": "Loading data"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-[108px] h-42 rounded-sm bg-gray-200 mb-5 animate-pulse2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-42 rounded-sm bg-gray-200 animate-pulse2" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.img,
        alt: "Vehicle",
        class: "w-16 h-16 mr-3"
      }, null, 8, _hoisted_3),
      _createElementVNode("p", null, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("p", null, _toDisplayString(_ctx.statsOne), 1),
            _createElementVNode("canvas", { id: _ctx.id }, null, 8, _hoisted_10)
          ]))
    ])
  ]))
}